import { useQuery } from "@apollo/client";
import { LoadingSpinner } from "pepsico-ds";
import { useContext } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { findInstantWinById } from "../../../graphql/queries/instantWinQueries";
import { convertDateToLocaleTz } from "../../../utils/commons";
import OutcomeRulesSetup from "../ActivitySetup/OutcomeRulesSetup";
import { isOutcomeRuleConfigured } from "../campaignUtils";
import {
  isRetailerConditionRule,
  isStoreConditionRule,
  isSurveyConditionRule,
} from "../rulesAndOutcomes/outcomes/conditionTypeUtils";
import ViewComponentsRenderer from "./ViewComponentsRenderer";

const WinningScheduleComponent = (props) => {
  const { programTimezone } = useContext(GlobalConfigContext);
  const { data, loading } = useQuery(findInstantWinById, {
    variables: {
      id: props.data?.instant_win_id,
    },
    skip: !props.data?.instant_win_id,
  });

  const outcome = props.definition;
  const pathname = window.location.pathname;
  const isSummary = pathname.includes("summary");

  return (
    <div>
      <div className="display-flex align-center" style={{ gap: "1rem" }}>
        {loading ? (
          <LoadingSpinner size={{ height: "16px", width: "16px" }} />
        ) : (
          <>
            <h5>Winning Schedule: {data?.findInstantWinById?.title}</h5>
            <p className="font-xs">
              From{" "}
              {convertDateToLocaleTz(
                data?.findInstantWinById?.startsAt,
                programTimezone
              )}{" "}
              -{" "}
              {convertDateToLocaleTz(
                data?.findInstantWinById?.endsAt,
                programTimezone
              )}
            </p>
          </>
        )}
      </div>

      {isSummary ? (
        outcome?.outcomeRules?.length > 0 &&
        outcome?.outcomeRules
          ?.filter(isOutcomeRuleConfigured)
          .filter(
            (rule) =>
              !isRetailerConditionRule(rule) &&
              !isStoreConditionRule(rule) &&
              !isSurveyConditionRule(rule)
          )
          .map((rule, i) => (
            <ViewComponentsRenderer
              data={rule.ruleData}
              inputSchema={rule.ruleDefinition?.inputSchema}
              customComponentName={rule.ruleDefinition?.slug}
              uiSchema={rule.ruleDefinition?.uiSchema || {}}
              key={rule.ruleDefinition?.slug + i + JSON.stringify(rule.ruleData)}
              ruleDefinition={rule.ruleDefinition}
            />
          ))
      ) : (
        <OutcomeRulesSetup
          outcome={outcome}
          updateOutcome={(updatedOutcome) =>
            props?.updateOutcome?.(updatedOutcome, props.index)
          }
        />
      )}
    </div>
  );
};

export default WinningScheduleComponent;
